/**
 * Filters a query string down to its utm_* params, so marketing attribution
 * survives a redirect while app-only params (e.g. ?foo=) are dropped.
 * Returns a leading-'?' query string, or '' when there are no utm params.
 */
export const utmParamsOnly = (search: string) => {
  const utm = new URLSearchParams();

  new URLSearchParams(search).forEach((value, key) => {
    if (key.toLowerCase().startsWith('utm_')) {
      utm.append(key, value);
    }
  });

  const query = utm.toString();

  return query ? `?${query}` : '';
};
